import React, { useState } from 'react';

const AsNumber = ({
    id,
    title,
    value,
    defaultValue,
    onChange,
    onBlur,
    disabled = false,
    allowFloat = false,
    disallowNegatives = false,
    digitLimit,
    labelProps,
    labelStyle,
    inputStyle,
    formatCurrency,
    formatNumber,
    formatNumberOptions,
    ...props
}) => {
    labelStyle = {
        display: 'block',
        ...labelStyle
    };

    inputStyle = {
        padding: 12,
        border: '1px solid #D7D7D7',
        borderRadius: 5,
        resize: 'vertical',
        contain: 'strict',
        display: 'block',
        textAlign: 'right',
        backgroundColor: '#FFFDF4',
        color: '#414141',
        ...(disabled ? { backgroundColor: '#F7F7F7' } : []),
        ...inputStyle
    };

    const [editMode, setEditMode] = useState(false);

    const reI = disallowNegatives ? /^\d+$/ : /^[+-]?\d+$/;
    const reF = disallowNegatives
        ? /^((\.\d+)|(\d+(\.\d+)?))$/
        : /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/;
    const rePartialF = disallowNegatives
        ? /^(\.0*|\.0*|\d+\.)?$/
        : /^([+-]|\.0*|[+-]\.0*|[+-]?\d+\.)?$/;

    const isValid = (v) =>
        // Allow the text box to be blank
        v === undefined ||
        v === '' ||
        // If floats aren't allowed, validate as integer
        (!allowFloat &&
            reI.test(v) &&
            (!digitLimit || v.length <= digitLimit)) || // If floats are allowed, then two integers may be sperated by a `.`
        (allowFloat &&
            (reF.test(v) || rePartialF.test(v)) &&
            (!digitLimit ||
                v.length <=
                    digitLimit +
                        (v.includes('.') +
                            (!disallowNegatives && v.includes('-')))));

    const exceedFractionDigitsLength = (num) => {
        const numStr = String(num);

        if (!numStr.includes('.')) return false;

        const count = numStr.split('.')[1].length;
        const maxFranctionDigits =
            formatNumberOptions?.maximumFractionDigits ?? 2;

        if (count <= maxFranctionDigits) return false;

        return true;
    };

    const handleInput = (e) => {
        const { value } = e.target;

        if (
            disabled ||
            !onChange ||
            !isValid(value) ||
            exceedFractionDigitsLength(value)
        )
            return;

        onChange(e);
    };

    const displayValue = editMode
        ? value
        : formatCurrency // If both formatCurrency and formatNumber are present, formatCurrency takes precedence
        ? formatCurrency(value)
        : formatNumber(value, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
              ...formatNumberOptions
          });

    const handleBlur = (event) => {
        setEditMode(false);

        if (typeof onBlur === 'function') {
            onBlur(event);
        }
    };

    const handleKeyUp = (event) => {
        // When hit Enter, trigger blur event. This allows users to confirm changes without moving focus. 
        if (event.key === 'Enter') {
            event.target.blur();
        }
    };

    return (
        <React.Fragment>
            <label
                {...labelProps}
                id={`${id}-label`}
                style={labelStyle}
                htmlFor='committedSpendInput'
            >
                {title}
            </label>
            <input
                {...props}
                id={id}
                value={displayValue ?? ''}
                defaultValue={defaultValue}
                disabled={disabled}
                onChange={handleInput}
                type='text'
                style={inputStyle}
                onFocus={() => setEditMode(true)}
                onBlur={handleBlur}
                onKeyUp={handleKeyUp}
            />
        </React.Fragment>
    );
};

export default AsNumber;
